import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		subForm: {
			margin: theme.spacing(2),
		},
		formElementGrid: {
			padding: theme.spacing(0.5),
		},
	}),
);

export const formClasses = useStyles;
